export default "__VITE_ASSET__79bd7e64__"